import $ from 'jquery'

if (window.location.href.indexOf('lekkerland.de') > -1) {
  $(document).ready(dhsv_vc_akademie_formular())
}

function dhsv_vc_akademie_formular() {
  const options = $('.dhsv_vc_akademie_formular').data('options')

  var lastValTraining,
    lastValModule = ''

  $(document).on('gform_post_render', function (event, form_id, current_page) {
    if (form_id === 4 && current_page === '1') {
      const training = $('#input_' + form_id + '_3')
      const module = $('#input_' + form_id + '_4')
      const event = $('#input_' + form_id + '_5')

      module.prop('disabled', true)
      event.prop('disabled', true)

      if (training.val()) {
        module.prop('disabled', false)
      }
      if (module.val()) {
        event.prop('disabled', false)
      }
      if (training.val()) {
        const moduleVal = module.val()
        const firstOption = module.children().first().clone()
        module.empty()
        module.append(firstOption)
        const trainingFound = options.find(
          option => option.program === training.val()
        )
        trainingFound.modules.forEach(function (item) {
          module.append(new Option(item.label, item.value))
        })
        module.val(moduleVal)
      }
      if (module.val()) {
        const eventVal = event.val()
        const firstOption = event.children().first().clone()
        event.empty()
        event.append(firstOption)
        const trainingFound = options.find(
          option => option.program === training.val()
        )
        const moduleFound = trainingFound.modules.find(
          option => option.value === parseInt(module.val())
        )
        moduleFound.events.forEach(function (item) {
          event.append(new Option(item.label, item.value))
        })
        event.val(eventVal)
      }
    }

    if (form_id === 4 && current_page === '4') {
      const participateSelf = $('#choice_' + form_id + '_16_1')
      if (participateSelf[0].checked) {
        const tableBody = $('#field_' + form_id + '_17 table tbody')
        tableBody.addClass('disabled')
      } else {
        const tableBody = $('#field_' + form_id + '_17 table tbody')
        tableBody.removeClass('disabled')
      }
    }

    $('.gform_wrapper select:not(.default_select)').SumoSelect()
  })

  if (window.gform) {
    window.gform.addAction(
      'gform_input_change',
      function (elem, formId, fieldId) {
        if (formId === '4') {
          const training = $('#input_' + formId + '_3')
          const module = $('#input_' + formId + '_4')
          const event = $('#input_' + formId + '_5')

          if (fieldId === '3' && lastValTraining !== training.val()) {
            if (training.val()) {
              const firstOption = module.children().first().clone()
              module.empty()
              module.append(firstOption)
              const trainingFound = options.find(
                option => option.program === training.val()
              )
              trainingFound.modules.forEach(function (item) {
                module.append(new Option(item.label, item.value))
              })
              lastValTraining = training.val()
            }
            module.val('').change()
            event.val('').change()
          }
          if (fieldId === '4' && lastValModule !== module.val()) {
            if (module.val()) {
              const firstOption = event.children().first().clone()
              event.empty()
              event.append(firstOption)
              const trainingFound = options.find(
                option => option.program === training.val()
              )
              const moduleFound = trainingFound.modules.find(
                option => option.value === parseInt(module.val())
              )
              moduleFound.events.forEach(function (item) {
                event.append(new Option(item.label, item.value))
              })
              lastValModule = module.val()
            }
            event.val('').change()
          }
          if (fieldId === '5') {
            //
          }
          if (['3', '4', '5'].includes(fieldId)) {
            module.prop('disabled', true)
            module[0].sumo.reload()
            event.prop('disabled', true)
            event[0].sumo.reload()

            if (training.val()) {
              module.prop('disabled', false)
              module[0].sumo.reload()
            } else {
              module[0].sumo.reload()
            }
            if (module.val()) {
              event.prop('disabled', false)
              event[0].sumo.reload()
            } else {
              event[0].sumo.reload()
            }
          }
          if (fieldId === '35.1') {
            if (elem.checked) {
              const salutation = $('#input_' + formId + '_36')
              salutation[0].sumo.reload()
            }
          }
          if (fieldId === '16.1') {
            const tableBody = $('#field_' + formId + '_17 table tbody')
            const firstListRow = tableBody.find('tr:first-child')
            const firstInput = firstListRow.children().eq(0).find('input')
            const secondInput = firstListRow.children().eq(1).find('input')
            if (elem.checked) {
              tableBody.addClass('disabled')
              const firstname = $('#input_' + formId + '_7')
              const lastname = $('#input_' + formId + '_8')

              firstInput.val(firstname.val()).change()
              secondInput.val(lastname.val()).change()
            } else {
              tableBody.removeClass('disabled')
              firstInput.val('').change()
              secondInput.val('').change()
            }
          }
          if (fieldId === '46') {
            if (elem.value) {
              const salutation = $('#input_' + formId + '_6')
              salutation[0].sumo.reload()
            }
          }
        }
      },
      10,
      3
    )
  }

  $(document).on('mousedown touchend', function (e) {
    const modal = $(
      '.dhsv_vc_akademie_formular .dhsv_vc_akademie_formular_modal.open'
    )
    const gform_body = modal.find('.gform_body')
    const gform_confirmation = modal.find('.gform_confirmation_wrapper ')
    const closeButton = modal.find(
      '.dhsv_vc_akademie_formular_modal_wrapper > i'
    )
    if (gform_body.length) {
      if (
        (!gform_body.is(e.target) && gform_body.has(e.target).length === 0) ||
        closeButton.is(e.target)
      ) {
        modal.removeClass('open')
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href
      }
    }
    if (gform_confirmation.length) {
      if (
        (!gform_confirmation.is(e.target) &&
          gform_confirmation.has(e.target).length === 0) ||
        closeButton.is(e.target)
      ) {
        modal.removeClass('open')
        // eslint-disable-next-line no-self-assign
        window.location.href = window.location.href
      }
    }
  })

  $('.dhsv_vc_akademie_formular_button').on('click', () => {
    const $modal = $('.dhsv_vc_akademie_formular_modal')
    $modal.addClass('open')
    const training = $('#input_' + 4 + '_3')
    training.change()
  })
}
